import React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from "@mui/material";
import { Field, FieldArray } from "formik";
import PropTypes from "prop-types";
import  {produce}  from "immer"; // Import Immer
import FormikLabel from "./FormLabel";

const CheckboxFieldComponent = ({ field, errors, touched }) => {
  const isSingleCheckbox =
    field.optionsReference?.options?.length === 1 && !field.multiple;

  return (
    <FormControl
      component="fieldset"
      fullWidth
      error={touched?.[field.fieldId] && !!errors?.[field.fieldId]}
    >
      <FormikLabel text={field.fieldName} required={field.required} />

      {isSingleCheckbox ? (
        <Field name={field.fieldId}>
          {({ field: formikField, form }) => {
            const option = field.optionsReference?.options?.[0];
            return (
              <FormControl
                fullWidth
                error={touched?.[field.fieldId] && !!errors?.[field.fieldId]}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formikField.value === true}
                      onChange={(e) => {
                        const newValue = e.target.checked; // `true` if checked, `false` if unchecked
                        form.setFieldValue(field.fieldId, newValue);

                        console.log("newValue", newValue);

                        // form.setFieldTouched(field.fieldId, true); // Mark as touched on change
                      }}
                      disabled={field.disabled}
                    />
                  }
                  label={option?.name || option?.value || field.fieldName}
                />
              </FormControl>
            );
          }}
        </Field>
      ) : (
        <FieldArray name={field.fieldId}>
          {({ push, remove, form }) => (
            <FormGroup row>
              {field.optionsReference?.options?.map((option, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={form.values[field.fieldId]?.includes(
                        option.value
                      )}
                      onChange={(e) => {
                        if (e.target.checked) {
                          push(option.value);
                        } else {
                          const idx = form.values[field.fieldId].indexOf(
                            option.value
                          );
                          if (idx !== -1) remove(idx);
                        }
                      }}
                      disabled={field.disabled}
                    />
                  }
                  label={option.name || option.value}
                />
              ))}
            </FormGroup>
          )}
        </FieldArray>
      )}

      <FormHelperText>
        {touched?.[field.fieldId] && errors?.[field.fieldId]}
      </FormHelperText>
    </FormControl>
  );
};

CheckboxFieldComponent.propTypes = {
  field: PropTypes.shape({
    fieldId: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    required: PropTypes.bool,
    multiple: PropTypes.bool,
    disabled: PropTypes.bool,
    optionsReference: PropTypes.shape({
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          name: PropTypes.string,
        })
      ),
    }),
  }).isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
};

export default CheckboxFieldComponent;
